import { useCallback } from 'react';

import { useHistory } from 'src/services/useHistory';
import { ROUTES } from 'src/routes';
import { updateUTMCampaign, usePageEvents } from '../../services';
import { useMainActions } from '../../store';

export const useHandlers = () => {
  const history = useHistory();
  const mainActions = useMainActions();
  const { trackSignUpClicked } = usePageEvents();

  const handleSignUpClick = useCallback(() => {
    trackSignUpClicked();

    updateUTMCampaign({
      utmCampaign: 'shared_document_signup',
      shareDocumentId: mainActions.getShareDocumentId(),
    });

    history.push(ROUTES.SIGN_UP);
  }, [trackSignUpClicked, mainActions, history]);

  return {
    handleSignUpClick,
  };
};
